$(document).ready(function () {
    const setSizes = function () {
        const isLarge = $.mediaQuery("lg");
        $(".tpl-cards-slider").each(function () {
            const wrapper = $(this).find(".wrapper");
            const slides = $(this).find(".slide");
            const totalSlides = slides.length;
            const size = (totalSlides + 1) * 500 + 400;
            const pb = size - $(this).width();
            wrapper.width(isLarge ? size : "");
            $(this).css("padding-bottom", isLarge ? pb : 0);
        });
    };

    setSizes();
    $(window).on("resize", setSizes);

    $(window).on("scroll", function () {
        const scroll = $(window).scrollTop();
        const isLarge = $.mediaQuery("lg");

        $(".tpl-cards-slider").each(function () {
            const inner = $(this).find(".inner");
            const wrapper = $(this).find(".wrapper");

            const top = $(this).offset().top - $.constants.menuHeight;
            const height =
                $(this).height() + parseInt($(this).css("padding-bottom"));
            const bottom = top + height + $.constants.menuHeight;

            if (!isLarge || scroll < top || scroll > bottom) {
                inner.css("position", "relative").css("top", 0);

                wrapper.css("transform", `translateX(0)`);
            } else {
                const tx = Math.min(scroll - top, height);
                inner
                    .css("position", "fixed")
                    .css("top", `${$.constants.menuHeight}px`);

                wrapper.css("transform", `translateX(-${tx}px)`);
            }
        });
    });
});
